import { FC } from 'react';
// components
import EditExcipientLabelComponent from 'components/main/ExcipientLabel/Edit';

const EditExcipientLabel: FC = () => <EditExcipientLabelComponent />;

export default EditExcipientLabel;
